import {
  useEffect, useMemo, useState
} from 'react';
import {
  FOOTER_HEIGHT_DESKTOP,
  FOOTER_HEIGHT_MOBILE,
  HEADER_HEIGHT_DESKTOP,
  HEADER_HEIGHT_MOBILE
} from '@/config/layout';
import { isBrowser, isTabletIOS } from '@/helpers/browser';

const useHeaderFooterHeights = () => {
  const [headerHeightMobile] = useState(HEADER_HEIGHT_MOBILE);
  const [headerHeightDesktop] = useState(HEADER_HEIGHT_DESKTOP);
  const [footerHeightMobile, setFooterHeightMobile] = useState(FOOTER_HEIGHT_MOBILE);
  const [footerHeightDesktop, setFooterHeightDesktop] = useState(FOOTER_HEIGHT_DESKTOP);

  const isBrowserMode = isBrowser();

  useEffect(() => {
    if (isBrowserMode && isTabletIOS()) {
      setFooterHeightDesktop(FOOTER_HEIGHT_DESKTOP + 32);
      setFooterHeightMobile(FOOTER_HEIGHT_MOBILE + 32);
    }
  }, [isBrowserMode]);

  return useMemo(() => ({
    headerHeightMobile,
    headerHeightDesktop,
    footerHeightMobile,
    footerHeightDesktop
  }), [headerHeightMobile, headerHeightDesktop, footerHeightMobile, footerHeightDesktop]);
};

export default useHeaderFooterHeights;